import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ba99846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fp" }
const _hoisted_2 = { class: "fp_list" }
const _hoisted_3 = { class: "fp_list_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createElementVNode("span", null, "计划生产数量：")
], -1))
const _hoisted_5 = { class: "fp_list_item_right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createElementVNode("span", null, "计划开工日期：")
], -1))
const _hoisted_7 = { class: "fp_list_item_right" }
const _hoisted_8 = {
  key: 0,
  class: "black"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("span", null, "生产设备")
], -1))
const _hoisted_11 = { class: "fp_list_item_right" }
const _hoisted_12 = {
  key: 0,
  class: "black"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "fp_list_item1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("span", null, "生产人员")
], -1))
const _hoisted_16 = { class: "fp_list_item_right" }
const _hoisted_17 = { class: "wu" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "fp_footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_22 = [
  _hoisted_21
]

import { ref, reactive, onMounted } from 'vue'
    import { gsdate } from "@/utils/utils"
    import { useRoute, useRouter } from "vue-router"
    import { distributeById, getFindAll, getDeviceByCondition } from '@/apis/PlanningAPI'
    import { Toast } from 'vant'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()

    // 控制选择设备
    const show1 = ref<boolean>(false)

    // 表单待提交数据
    const form = reactive<{equipmentName: string, num: string, startTime: string, personnelId: Array<any>, equipmentId: string}>({
        num: route.query.num as string,        // 生产数量
        startTime: gsdate(new Date()),      // 开始时间
        equipmentId: '',    // 设备id
        equipmentName: '',    // 设备名称
        personnelId: []    // 人员id
    })

    // 设备数据
    let equipment: any = ref([])

    // 人员数据
    let personnelData = ref([])

    // 控制选择日期显示隐藏
    const isOpenDate = ref<boolean>(false)

    // 确认选择日期
    const onConfirm = (values: any) => {
        form.startTime = gsdate(values)
        isOpenDate.value = false;
    }

    // 打开选择时间弹框
    const openTime = () => {
        isOpenDate.value = true
    }

    // 打开选择设备弹框
    const openSB = () => {
        show1.value = true
    }

    // 确认选择设备
    const onConfirms1 = (value: any, index: any) => {
        form.equipmentId = value.id
        form.equipmentName = value.text
        personnelData.value = []
        getFindAll({
            deviceId: form.equipmentId
        }).then(res => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                form.personnelId = []
                let arr: any = []
                res.data.forEach((item: any) => {
                    arr.push({ text: item.dmodel.name + '-' + item.umodel.name, id: item.userId })
                })
                personnelData.value = arr
            }
            show1.value = false
        })
    };

    // 关闭生产设备
    const onCancel1 = () => {
        show1.value = false
    }

    // 返回
    const go = () => {
        router.go(-1)
    }

    // 提交分配
    const submit = () => {
        if (!form.num) return Toast('计划生产数量不能为空！')
        if (!form.startTime) return Toast('计划开始日期不能为空！')
        distributeById({
            planId: route.query.jhid,
            planNum: form.num,
            planDate: form.startTime,
            proGroupId: form.equipmentId,
            proUserList: form.personnelId
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: '分配成功', duration: 2000, forbidClick: true })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 查询设备
    const getDeviceByConditions = () => {
        getDeviceByCondition({})
            .then(res => {
                if (res.code === 200) {
                    res.data.forEach((element: any) => {
                        equipment.value.push({ text: element.code + '-' + element.name, id: element.id })
                    })
                }
            })
    }

    onMounted(() => {
        getDeviceByConditions()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).num) = $event)),
              placeholder: "请输入"
            }, null, 512), [
              [_vModelText, _unref(form).num]
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "fp_list_item",
          onClick: openTime
        }, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_unref(form).startTime)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(form).startTime), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "年 / 月 / 日")),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999"
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "fp_list_item",
          onClick: openSB
        }, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_unref(form).equipmentName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(form).equipmentName), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "请选择")),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999"
            })
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createVNode(_component_van_checkbox_group, {
              modelValue: _unref(form).personnelId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).personnelId) = $event)),
              direction: "horizontal"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personnelData), (item) => {
                  return (_openBlock(), _createBlock(_component_van_checkbox, {
                    name: item.id,
                    "checked-color": "#4275FC"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"]), [
              [_vShow, _unref(personnelData).length > 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_19, 512), [
              [_vShow, _unref(personnelData).length === 0]
            ])
          ])
        ], 512), [
          [_vShow, _unref(form).equipmentName]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: "fp_footer_close",
          onClick: go
        }, "取消"),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "fp_footer_submit",
          onClick: submit
        }, _hoisted_22)), [
          [_directive_preventReClick]
        ])
      ])
    ]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      color: "#4275FC",
      onConfirm: onConfirm
    }, null, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: show1.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((show1).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择生产设备",
          columns: _unref(equipment),
          onConfirm: onConfirms1,
          onCancel: onCancel1
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})